<script>
    import { nanoid } from "nanoid";
	import { acceptedFileUploadList } from "../config";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
    import DropZone from './DropZone.svelte';

    export let id = `fileUploader_${nanoid(4)}`;
	export let disabled = null;
	export let registrationToken = null;
	export let documentList = [];
    export let filenamePrefix = "";
    export let message = "<strong>Upload files for your registration</strong><br />Drop files here or click to upload.";
    export let maxFiles = null;
    export let htmlLabel=null;

    let options = {
            url: "/api/file-upload?token=" + registrationToken,
            acceptedFiles: acceptedFileUploadList,
            fileUploadToken: registrationToken,
            maxFiles
        };

    let dropzoneClass = `dropzone_${nanoid(4)}`;
    documentList = documentList || [];
    console.log("documentList", documentList, dropzoneClass)
</script>

    <FormRow>
        <FormColumn>
            {@html htmlLabel}
            <DropZone
                {disabled}
                {options}
                {id}
                {filenamePrefix}
			    {message}
                {dropzoneClass}
                bind:documentList={documentList}>
            </DropZone>
        </FormColumn>
    </FormRow>

<style>
</style>